import { createContext, useContext } from "react";
import { useDashboard } from "../hooks";
const Context = createContext();

export const DashboardProvider = ({ children }) => {
  return <Context.Provider value={useDashboard()}>{children}</Context.Provider>;
};

export const useDashboardContext = () => useContext(Context);
